import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { selectIsModalTemplateDetailsEnabled, selectModalTemplateDetailsData } from '../../../redux/main/main.selectors';
import { toggleTemplateDetails, toggleModalTemplateClone } from '../../../redux/main/main.actions';


import Modal from '../Modal/Modal';

import './ModalTemplateDetails.scss';

export const ModalTemplateDetails = () => {
    const dispatch = useDispatch();
    const history = useHistory();

    const isOpen = useSelector(selectIsModalTemplateDetailsEnabled);
    const modalData = useSelector(selectModalTemplateDetailsData);

    const [title, setTitle] = useState(modalData?.template?.title || '');
    const [description, setDescription] = useState(modalData?.template?.description || '');

    useEffect(() => {
        if (!modalData?.template?.title) return;

        if (title !== modalData?.template?.title) {
            setTitle(modalData?.template?.title);
        }

        if (description !== modalData?.template?.description) {
            setDescription(modalData?.template?.description);
        }
        return () => { };
    }, [modalData]);

    const handleCancel = () => {
        dispatch(toggleTemplateDetails(null));
    };

    const handleRender = () => {
    };

    const handlePreview = () => {
        dispatch(toggleTemplateDetails(null));
        const url = `/d/${modalData?.template?.id}`;
        history.push(url);
    };

    const handleUseTemplate = () => {
        dispatch(toggleTemplateDetails(null));
        dispatch(toggleModalTemplateClone(modalData?.template?.id));
    };

    return (
        <Modal
            isOpen={isOpen}
            modalClass={`modal-template-details`}
            onCancel={handleCancel}
            onShouldRender={handleRender}
        >
            <div className="modal-content-header">{`${title}`}</div>
            <div className='modal-content-body description-text'>{`${description}`}</div>
            <div className="modal-content-body">
                <button className='button-second' onClick={() => handlePreview()}>Preview</button>
                <button onClick={() => handleUseTemplate()}>Use template</button>
            </div>
        </Modal>
    );
};

export default ModalTemplateDetails;
